class EventManager {
    private events = {};

    public add(target, event, cb) {
        if (!this.events[event]) {
            this.events[event] = {
                targets: []
            };
        }

        let _target = this.events[event].targets.find(_target => {
            return _target && (_target.node.isSameNode && _target.node.isSameNode(target) || _target.node === target);
        });


        if (!_target) {
            let fn = (e) => {
                this.execCallbacks(_target, e);
            };

            _target = {
                node: target,
                callbacks: [],
                listener: target.addEventListener(event, fn),
                clear: () => target.removeEventListener(event, fn)
            };

            this.events[event].targets.push(_target);
        }


        _target.callbacks.push(cb);

        return () => {
            let index = _target.callbacks.indexOf(cb);

            if (index >= 0) {
                _target.callbacks.splice(index, 1);

                if (!_target.callbacks.length) {
                    _target.clear();
                    delete this.events[event].targets[this.events[event].targets.indexOf(_target)];
                }
            }
        };
    }

    public forceEvent(target, event) {
        if (this.events[event] && this.events[event].targets[target]) {
            this.execCallbacks(target, event);
        }
    }

    private execCallbacks(target, e?) {
        for (let i = target.callbacks.length - 1; i >= 0; i--) {
            target.callbacks[target.callbacks.length - 1 - i](e);
        }
    }
}

export default new EventManager();